module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button-component', {
    staticClass: "ReadMoreButton",
    attrs: {
      "route": _vm.route,
      "label": _vm.label,
      "icon": _vm.icon,
      "icon-on-right": "",
      "light": "",
      "small": ""
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42a083c8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ReadMoreButton.vue
// module id = 760
// module chunks = 1474